import { makeAutoObservable } from "mobx";

// NB. Dropped rightDrawerMinWidth from 560 to 360 - may have unintended consquences!
// And back again

class UiStore {
  theme = "day";
  leftDrawerMinWidth = 320
  leftDrawerMaxWidth = 640
  rightDrawerMinWidth = 560 
  rightDrawerWidth = 560
  rightDrawerMaxWidth = 1120

  constructor() {
    makeAutoObservable(this)
}
  setRightDrawerWidth = (width: number) => {
    //console.log(width)  
    this.rightDrawerWidth = width
}

  toggleTheme = () => {
    this.theme = this.theme === "day" ? "night" : "day";
  };
}

export default new UiStore();
